import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Badge, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';

const Changelog = () => {
  const [changelog, setChangelog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/CHANGELOG.json')
      .then(response => response.json())
      .then(data => {
        setChangelog(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading changelog:', error);
        setLoading(false);
      });
  }, []);

  const getVersionBadgeColor = (type) => {
    switch (type) {
      case 'major': return 'danger';
      case 'minor': return 'warning';
      case 'patch': return 'info';
      default: return 'secondary';
    }
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'Nuevas Funcionalidades': 'ri-star-line',
      'Mejoras': 'ri-arrow-up-circle-line',
      'Correcciones': 'ri-tools-line',
      'Optimizaciones': 'ri-speed-line',
      'Técnicas': 'ri-code-line',
      'Componentes Nuevos': 'ri-layout-line',
      'Herramientas': 'ri-settings-3-line'
    };
    return icons[category] || 'ri-checkbox-circle-line';
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* Header */}
        <Row>
          <Col xs={12}>
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">
                <i className="ri-file-list-3-line me-2"></i>
                Registro de Cambios
              </h4>
              <div className="page-title-right">
                <Link to="/dashboard" className="btn btn-soft-primary btn-sm">
                  <i className="ri-arrow-left-line me-1"></i>
                  Volver al Dashboard
                </Link>
              </div>
            </div>
          </Col>
        </Row>

        {/* Version Actual */}
        {changelog && (
          <Row className="mb-4">
            <Col xs={12}>
              <Alert color="primary" className="border-primary">
                <div className="d-flex align-items-center">
                  <i className="ri-information-line fs-20 me-3"></i>
                  <div>
                    <h5 className="alert-heading mb-1">Versión Actual</h5>
                    <p className="mb-0">
                      <strong>{changelog.version}</strong> 
                      <span className="text-muted ms-2">
                        (Commit: <code>{changelog.releases[0].commit}</code>)
                      </span>
                    </p>
                  </div>
                </div>
              </Alert>
            </Col>
          </Row>
        )}

        {/* Releases */}
        <Row>
          <Col xs={12}>
            {changelog && changelog.releases.map((release, index) => (
              <Card key={index} className="mb-4">
                <CardBody>
                  {/* Release Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div>
                      <h4 className="card-title mb-2">
                        <Badge color={getVersionBadgeColor(release.type)} className="me-2">
                          v{release.version}
                        </Badge>
                        {release.title}
                      </h4>
                      <div className="text-muted">
                        <i className="ri-calendar-line me-1"></i>
                        {new Date(release.date + 'T12:00:00').toLocaleDateString('es-ES', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                        <span className="ms-3">
                          <i className="ri-git-commit-line me-1"></i>
                          Commit: <code className="text-primary">{release.commit}</code>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Changes by Category */}
                  {release.changes.map((changeGroup, cgIndex) => (
                    <div key={cgIndex} className="mb-4">
                      <h5 className="text-primary mb-3">
                        <i className={`${getCategoryIcon(changeGroup.category)} me-2`}></i>
                        {changeGroup.category}
                      </h5>
                      <ul className="list-unstyled mb-0">
                        {changeGroup.items.map((item, itemIndex) => (
                          <li key={itemIndex} className="mb-2">
                            <i className="ri-checkbox-circle-fill text-success me-2"></i>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </CardBody>
              </Card>
            ))}
          </Col>
        </Row>

        {/* Footer Info */}
        <Row>
          <Col xs={12}>
            <Card className="bg-light border-0">
              <CardBody>
                <div className="text-center text-muted">
                  <i className="ri-information-line me-1"></i>
                  <small>
                    Para más información sobre las actualizaciones, consulta la documentación del dashboard.
                  </small>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Changelog;
